/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Alpine from 'alpinejs';
window.Alpine = Alpine;

window.$ = window.jQuery = require('jquery');
require('./bootstrap');

require('./buttons.server-side.js'); // DataTables.net Buttons from the Laravel bindings package
require('datatables.net-buttons/js/buttons.colVis'); // Load after the custom button definitions
window.Cookies = require('js-cookie');
window.ClipboardJS = require('clipboard');

window.AutoNumeric = require('autonumeric/dist/autoNumeric.min');

window.bsCustomFileInput = require('bs-custom-file-input');

require('./ie11-polyfills');
window.Tabulator = require('tabulator-tables');

window.JsDiff = require('diff');

$(document).ready(function () {
    $(document).on("wheel", "input[type=number]", function (e) {
        $(this).blur();
    });

    var clipboardjs_btn = new ClipboardJS('.btn');
    clipboardjs_btn.on('success', function (e) {
        $(e.trigger).focus().tooltip({ title: 'Copied!', show: 'manual' }).tooltip('show').on('shown.bs.tooltip', function () {
            var tt_element = $(this);

            // Throw the tooltip away after 2.5s
            setTimeout(function () {
                tt_element.tooltip('hide').tooltip('dispose');
            }, 2500);
        });
    });

    if ($('input.dollars').length > 0) {
        AutoNumeric.multiple('input.dollars', {
            unformatOnSubmit: true,
            modifyValueOnWheel: false,
            onInvalidPaste: 'ignore',
        });

        // AutoNumeric's handlers break event propagation, so fix that.
        $('input.dollars').change(function (e) {
            $(e.target).closest('form').change();
        });
    }

    // Set up date pickers
    $('.date-picker').datepicker({
        format: 'yyyy-mm-dd',
        todayBtn: 'linked',
        todayHighlight: true,
        autoclose: true,
    });

    // If the date pickers have an input group addon (an icon, basically), make that clickable:
    $('.date-picker').parent().find('span.input-group-prepend').click(function (e) {
        field = $(e.target).parents('.input-group').find('.date-picker')
        field.datepicker('show');
    });

    $('[data-toggle="tooltip"]').tooltip();

    bsCustomFileInput.init();
});

require('./pii_control.js');

// Enable popovers
$(document).ready(function () {
    $('[data-toggle="popover"]').popover()
});

$(document).ready(function() {
    $('.dropdown-toggle').on('click', function(e) {
        if ($(this).next('.dropdown-menu').length) {
            e.preventDefault();
            e.stopPropagation();
            $(this).next('.dropdown-menu').toggle();
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    Alpine.start();
});
